function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { useRef, useMemo, createRef } from 'react';

var useRefs = function useRefs(arr) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var refs = useRef([]);

  if (!Array.isArray(arr)) {
    throw new Error("The useRefs hooks must be given an array, got \"".concat(_typeof(arr), "\"."));
  }

  refs.current = useMemo(function () {
    return arr.map(function (_, i) {
      var _refs$current$i;

      return (_refs$current$i = refs.current[i]) !== null && _refs$current$i !== void 0 ? _refs$current$i : /*#__PURE__*/createRef();
    });
  }, dependencies);
  return (refs === null || refs === void 0 ? void 0 : refs.current) || [];
};

export default useRefs;